export default __webpack_public_path__ + "static/media/newImg4.6d8bf90f.svg";